module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gFB4v"))).then(() => parcelRequire('1iHdE'));